var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-home-page"},[_c('img',{attrs:{"src":_vm.$globalHeader.imgUrl + '/static/miniprogram/home.png'}}),_c('p',[_vm._v("请使用微信“扫一扫”，进入小程序操作")]),_c('el-button',{staticClass:"open-mini",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.handleClick}},[_vm._v("打开小程序")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }